import cls from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { MediaProps } from './types';
import useMediaStyles from './mediaStyles';
import VideoMedia from './VideoMedia';

function Media({
  children,
  ytEmbedVideoUrl,
  src,
  srcSet,
  sizes,
  alt,
  onClick,
  inverse,
}: MediaProps) {
  const classes = useMediaStyles();

  switch (true) {
    case Boolean(children): {
      return <div className={classes.childContainer}>{children}</div>;
    }
    case Boolean(ytEmbedVideoUrl): {
      return <VideoMedia url={ytEmbedVideoUrl} />;
    }

    default: {
      return (
        <div className={cls(classes.imgContainer, classes.normal, inverse && classes.inverse)}>
          <LazyLoadImage
            className={classes.img}
            src={src}
            srcSet={srcSet}
            sizes={sizes}
            alt={alt}
            onClick={onClick}
          />
        </div>
      );
    }
  }
}

export default Media;
